import React from "react";
import { observer } from "mobx-react";

import { EventOffer } from "@gp/offer";

import {
	EventName,
	EventMatchTime,
	EventTeamAggregatedScore,
} from "@features/offer/shared/event/details";
import { EventTeamsInfo } from "./EventTeamsInfo";

export const PrematchEventInfo = observer(function PrematchEventInfo({
	event,
}: {
	event: EventOffer;
}) {
	if (event.name) {
		return <EventName event={event} />;
	}

	return (
		<EventTeamsInfo event={event}>
			<div className="event__middle">
				<EventMatchTime event={event} />
				{event.result?.aggregateScore && (
					<div className="event__aggregate">
						<EventTeamAggregatedScore event={event} team="home" />
						<span className="event__aggregate__middle">-</span>
						<EventTeamAggregatedScore event={event} team="away" />
					</div>
				)}
			</div>
		</EventTeamsInfo>
	);
});
